import { CustomerFilterValues } from "./types";

export const defaultCustomerFilterValues: CustomerFilterValues = {
  isRetailerCusAccount: false,
  nonRetailerCustomer: false,
};

export const customerFilterValuesToApiInput = (
  filterValues: CustomerFilterValues
) => {
  let v = {};

  if (filterValues.isRetailerCusAccount) {
    v = {
      ...v,
      isRetailerCusAccount: {
        eq: true,
      },
    };
  }

  if (filterValues.nonRetailerCustomer) {
    v = {
      ...v,
      retailerId: {
        isNull: true,
      },
    };
  }

  return v;
};
